<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import InputSwitch from 'primevue/inputswitch';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "content-add",
  data() {
    return {
      v$: useVuelidate(),
      gradeSlug: this.$route.params.gradeSlug,
      title: "",
      description: "",
      can_skip: false,
      is_file: true,
      fileData: "",
      link: "",
      formSending: false,
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
      type: null, // will be set below
      typeOptions: [
        {
          label: 'ملف',
          value: 'pdf'
        },
        {
          label: 'فيديو',
          value: 'video'
        },
        {
          label: 'صوت',
          value: 'audio'
        },
        // {
        //   label: 'إمتحان',
        //   value: 'exam'
        // }
      ]
    };
  },
  components: {
    Breadcrumb,
    InputText,
    Dropdown,
    InputSwitch
  },
  validations() {
    return {
      title: { required },
      // description: { required },
      // can_skip: { required },
      type: { required },
      is_file: { required },
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "المحتوى", path: `/${this.gradeSlug}/content` },
        { name: "إضافة محتوى", path: `/${this.gradeSlug}/content/add` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
    },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        // formData.append('can_skip', this.can_skip ? 1 : 0);
        formData.append('lesson_id', this.lesson?.id ?? this.unit?.id ?? this.branch?.id);
        formData.append('type', this.type?.value);
        formData.append('is_file', this.is_file ? 1 : 0);
        if (this.is_file && this.fileData) {
          formData.append('file', this.fileData);
        }
        if (!this.is_file && this.link) {
          formData.append('link', this.link);
        }
        this.formSending = true;
        axios
            .post('/contents', formData)
            .then(() => {
              this.formSending = false;
              this.resetForm();
              Swal.fire({ position: "center", icon: "success", title: "تم الاضافه بنجاح" });
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({ position: "center", icon: "error", title: error.response.data.message });
            });
      }
    },
    resetForm() {
      this.v$.$reset();
      this.title = "";
      this.description = "";
      // this.can_skip = false;
      this.type = null;
      this.is_file = true;
      this.fileData = "";
      this.link = "";
      this.lesson = null;
    },
    fetchBranch() {
      axios
          .get(`/lessons?type=1&academic_year_id=${this.gradeId}`)
          .then((response) => { this.branches = response.data.data; })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch?.id;
      axios
          .get(`/lessons?type=2&academic_year_id=${this.gradeId}&parent_id=${branchId}`)
          .then((response) => { this.units = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const unitId = this.unit?.id;
      axios
          .get(`/lessons?type=3&academic_year_id=${this.gradeId}&parent_id=${unitId}`)
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelBranch(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelUnit(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelLesson(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
  },
  async mounted() {
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    this.fetchBranch();
    if (!this.type && this.typeOptions.length) {
      this.type = this.typeOptions[0];
    }
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-cloud-upload"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة محتوى</h1>
        <p class="form-page-header__subtitle">رفع ملفات أو روابط للطلاب</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <!-- Content type -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-th-large"></i></div>
            <span class="form-card__title">نوع المحتوى <span style="color:var(--color-danger);font-size:0.75rem;">*</span></span>
          </div>
          <div class="form-card__body">
            <div class="type-selector">
              <label
                v-for="option in typeOptions"
                :key="option.value"
                :class="['type-selector__item', { active: type?.value === option.value }]"
              >
                <input type="radio" v-model="type" :value="option" class="d-none" />
                <i :class="`pi ${option.value === 'pdf' ? 'pi-file-pdf' : option.value === 'video' ? 'pi-video' : 'pi-volume-up'}`"></i>
                {{ option.label }}
              </label>
            </div>
            <span class="field-error mt-2" v-if="v$.type.$error">
              <i class="pi pi-exclamation-circle"></i> برجاء اختيار نوع المحتوى
            </span>
          </div>
        </div>

        <!-- Location hierarchy -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-sitemap"></i></div>
            <span class="form-card__title">الموقع في المنهج</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="branch">الفرع</label>
                  <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-100" @update:model-value="fetchUnits" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="unit">الوحدة</label>
                  <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحدة" class="w-100" @update:model-value="fetchLessons" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="lesson">الدرس</label>
                  <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Content details -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-pencil"></i></div>
            <span class="form-card__title">تفاصيل المحتوى</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="title">
                    اسم المحتوى <span class="required">*</span>
                  </label>
                  <InputText id="title" v-model="title" placeholder="أدخل اسم المحتوى" class="w-100" />
                  <span class="field-error" v-if="v$.title.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال اسم المحتوى
                  </span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="description">
                    الوصف <span class="optional">اختياري</span>
                  </label>
                  <InputText id="description" v-model="description" placeholder="أدخل وصف المحتوى" class="w-100" />
                </div>
              </div>
            </div>

            <!-- Source toggle -->
            <div class="source-toggle mt-4">
              <i class="pi pi-file" style="color: var(--text-secondary);"></i>
              <span class="source-toggle__label">رفع ملف</span>
              <InputSwitch id="isFile" v-model="is_file" />
              <span class="source-toggle__hint">{{ is_file ? 'سيتم رفع ملف' : 'سيتم إدخال رابط خارجي' }}</span>
            </div>

            <!-- File upload -->
            <div class="mt-4" v-if="is_file">
              <label class="field-label">الملف</label>
              <div :class="['upload-zone', { 'upload-zone--has-file': fileData }]">
                <div class="upload-zone__icon">
                  <i :class="`pi ${fileData ? 'pi-check' : 'pi-cloud-upload'}`"></i>
                </div>
                <p class="upload-zone__label">{{ fileData ? fileData.name : 'اضغط لاختيار ملف' }}</p>
                <p class="upload-zone__hint" v-if="!fileData">PDF, MP4, MP3 وغيرها</p>
                <input type="file" @change="onFileChange" accept=".pdf,.mp4,.mp3,.avi,.mov" />
              </div>
            </div>

            <!-- URL input -->
            <div class="mt-4" v-else>
              <div class="form-field">
                <label class="field-label" for="link">رابط المحتوى</label>
                <InputText id="link" v-model="link" placeholder="https://..." class="w-100" dir="ltr" />
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الإرسال...' : 'حفظ المحتوى' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>